/**
 * @name app.common.directives.contactModal.ContactModalDirective
 * @date 10/05/2015
 * @copyright 2015 Empower Retirement
 *
 */

import ContactOpenModalController from "./ContactOpenModalController";

var ContactModalDirective = function ($modal) {
    return {
        restrict: "A",
        controller: "ContactModalController",
        link: function ($scope, element, attr) {
            $scope.openContactModal = function () {
                var modalInstance = $modal.open({
                    template:
                        '<div class="modal-header">' +
                        '<h1 id="labelModalReviewChanges"  class="red">' +
                        '{{"footer.customerSupport.contactUsTitle"  | translate }}' +
                        "</h1>" +
                        "</div>" +
                        '<div class="modal-body">' +
                        '<h4 class="text-blue text-normal pad-top">' +
                        '{{"footer.customerSupport.corpPlanNonNY"  | translate }}' +
                        "</h4>" +
                        '<p class="flush-bottom"><a href="tel:' +
                        '{{"footer.customerSupport.corpPlanNonNYPhone"  | translate }}' +
                        '">' +
                        $scope.footer.customerSupport.corpPlanNonNYPhone +
                        "</a>&nbsp;&nbsp;&nbsp;&nbsp;" +
                        $scope.footer.customerSupport.corpPlanNonNYTTY +
                        "</p>" +
                        '<h4 class="text-blue text-normal pad-top">' +
                        '{{"footer.customerSupport.govPlanNonNY"  | translate }}' +
                        "</h4>" +
                        '<p class="flush-bottom"><a href="tel:' +
                        '{{"footer.customerSupport.govPlanNonNYPhone"  | translate }}' +
                        '">' +
                        $scope.footer.customerSupport.govPlanNonNYPhone +
                        "</a>&nbsp;&nbsp;&nbsp;&nbsp;" +
                        $scope.footer.customerSupport.govPlanNonNYTTY +
                        "</p>" +
                        '<h4 class="text-blue text-normal pad-top">' +
                        '{{"footer.customerSupport.corpPlanNY"  | translate }}' +
                        "</h4>" +
                        '<p class="flush-bottom"><a href="tel:' +
                        '{{"footer.customerSupport.corpPlanNYPhone"  | translate }}' +
                        '">' +
                        $scope.footer.customerSupport.corpPlanNYPhone +
                        "</a></p>" +
                        "</div>" +
                        '<div class="modal-footer">' +
                        '<a ng-click="cancel()" class="btn btn-link">Dismiss</a>' +
                        "</div>",
                    controller: ContactOpenModalController,
                    controllerAs: "ctrl",
                    size: "md",
                    windowClass: "modal-wrapper"
                });
            };
        }
    };
};
ContactModalDirective.$inject = ["$modal", "ContactModalDirective"];
export default ContactModalDirective;
